export default __webpack_public_path__ + "static/media/no-notifications.e5270a6d.svg";